import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreProductComponent } from './store-product.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [StoreProductComponent],
  imports: [CommonModule, NgxSpinnerModule],
  exports: [StoreProductComponent],
})
export class StoreProductModule {}
